import { createContext, useState, useMemo } from "react";

export const MixAndMatchContext = createContext();

export const MixAndMatchProvider = ({ children }) => {
  const [isMixAndMatchSection, setIsMixAndMatchSection] = useState(false);
  const [flexiValueMixAndMatch, setFlexiValueMixAndMatch] = useState(0);
  const [miValueMixAndMatch, setMiValueMixAndMatch] = useState(0);
  const [faiValueMixAndMatch, setFaiValueMixAndMatch] = useState(0);
  const [annuityValueMixAndMatch, setAnnuityValueMixAndMatch] = useState(0);
  const [legacyValueMixAndMatch, setLegacyValueMixAndMatch] = useState(0);
  const [safetyValueMixAndMatch, setSafetyValueMixAndMatch] = useState(0);

  const resetMixAndMatchValues = () => {
    setIsMixAndMatchSection(false);
    setFlexiValueMixAndMatch(0);
    setMiValueMixAndMatch(0);
    setFaiValueMixAndMatch(0);
    setAnnuityValueMixAndMatch(0);
    setLegacyValueMixAndMatch(0);
    setSafetyValueMixAndMatch(0);
  };

  const value = useMemo(
    () => ({
      isMixAndMatchSection,
      setIsMixAndMatchSection,
      flexiValueMixAndMatch,
      setFlexiValueMixAndMatch,
      miValueMixAndMatch,
      setMiValueMixAndMatch,
      faiValueMixAndMatch,
      setFaiValueMixAndMatch,
      annuityValueMixAndMatch,
      setAnnuityValueMixAndMatch,
      legacyValueMixAndMatch,
      setLegacyValueMixAndMatch,
      safetyValueMixAndMatch,
      setSafetyValueMixAndMatch,
      resetMixAndMatchValues,
    }),
    [
      isMixAndMatchSection,
      flexiValueMixAndMatch,
      miValueMixAndMatch,
      faiValueMixAndMatch,
      annuityValueMixAndMatch,
      legacyValueMixAndMatch,
      safetyValueMixAndMatch,
    ],
  );

  return (
    <MixAndMatchContext.Provider value={value}>
      {children}
    </MixAndMatchContext.Provider>
  );
};
